import { FetchSessionResponse } from "@flosum-auth/contracts";

export const AUTH_MODULE_NAMESPACE = "auth";

export enum LoginStep {
  TENANT = "TENANT",
  CREDENTIAL = "CREDENTIAL",
}

type AuthenticatedUser = FetchSessionResponse;

export type AuthState = {
  user: AuthenticatedUser | null;
};

export type AuthStoreDefinition = {
  auth: AuthState;
};
